export default __webpack_public_path__ + "media/zurb/img/playground/ux-design-stack-3aeaf9e4c0ef59942a89eb2db2226032.png";